"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodesEnum = void 0;
var CodesEnum;
(function (CodesEnum) {
    CodesEnum["Success"] = "success";
    CodesEnum["NotFound"] = "not-found";
    CodesEnum["BadRequest"] = "bad-request";
    CodesEnum["Unauthorized"] = "unauthorized";
    CodesEnum["Unknown"] = "unknown";
})(CodesEnum = exports.CodesEnum || (exports.CodesEnum = {}));
//# sourceMappingURL=types.js.map